import { render, staticRenderFns } from "./DynamicChart.vue?vue&type=template&id=0af13e23"
import script from "./DynamicChart.vue?vue&type=script&lang=js"
export * from "./DynamicChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports